import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Dropdown.css";

function Dropdown({ setDropdown, setMenuClick }) {
  const MenuItems = [
    { key: "photography" },
    { key: "soccer" },
  ];
  const { t } = useTranslation("common");

  const closeMenus = (e) => {
    setDropdown(false);
    setMenuClick(false);
    if (e.target) e.target.blur();
  };

  return (
    <ul className="dropdown-menu">
      {MenuItems.map((item) => (
        <li key={item.key}>
          <NavLink
            className="dropdown-link"
            to={`/hobbies#${item.key}`}
            onClick={closeMenus}
          >
            {t(`dropdown.${item.key}`)}
          </NavLink>
        </li>
      ))}
    </ul>
  );
}

export default Dropdown;